import * as XLSX from 'xlsx'

const getByPath = (obj, path) =>
  path ? path.split('.').reduce((acc, k) => (acc == null ? acc : acc[k]), obj) : undefined

// Menú de exportación para @material-table/core (v6 usa options.exportMenu)
// Exporta TODAS las filas que cumplen la búsqueda/filtros, no solo la página visible.
export const exportMenuXlsx = (fileName, onEmpty) => [
  {
    label: 'Exportar a Excel',
    exportFunc: (cols, datas, extra) => {
      const all = extra && extra.searchedData
      const fromRaw = Array.isArray(all) && all.length > 0
      const source = fromRaw ? all : datas
      if (!source || source.length === 0) {
        if (onEmpty) onEmpty('No existen datos a exportar.')
        return
      }
      const header = cols.map((c) => c.title)
      const rows = source.map((row) =>
        cols.map((c) => {
          let v
          if (fromRaw) {
            v =
              typeof c.customExport === 'function'
                ? c.customExport(row)
                : getByPath(row, c.field)
          } else {
            v = row[c.field]
          }
          return v instanceof Date ? v.toLocaleDateString('es-EC') : v
        })
      )
      const ws = XLSX.utils.aoa_to_sheet([header, ...rows])
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Datos')
      XLSX.writeFile(wb, `${fileName || 'Reporte'}.xlsx`)
    }
  }
]
